import React, { createContext, useEffect, useReducer, useState } from 'react';


import topApi from '../../components/api/ToPApi';
import { LoginData, LoginResponse, Resource, ResourceResponse, User } from '../../models/interfaces';
import { AuthState, authReducer } from './AuthReducer';

type AuthContextProps = {
    errorMessage: string;
    successMessage: string;
    token: string | null;
    user: User | null;
    status: 'checking' | 'authenticated' | 'not-authenticated';
    resources: Resource[];
    login: (loginData: LoginData) => void;
    loginWithOracleCode: (code) => Promise<boolean>;
    logout: () => void;
    resetPassword: (username: string) => void;
    removeError: () => void;
}

const authInicialState: AuthState = {
    status: 'checking',
    token: null,
    user: null,
    errorMessage: '',
    successMessage: ''
}



export const AuthContext = createContext({} as AuthContextProps);

export const AuthProvider = ({ children }: any) => {

    const [state, dispatch] = useReducer(authReducer, authInicialState);
    const [resources, setResources] = useState([]);


    useEffect(() => {
        checkToken();
    }, [])

    const checkToken = async () => {

        const token = await localStorage.getItem('token');

        // No token, no autenticado
        if (!token) return dispatch({ type: 'notAuthenticated' });

        // Hay token

        try {
            const resp = await topApi.get('/auth');
            if (resp.status !== 200) {
                return dispatch({ type: 'notAuthenticated' });
            }

            if (resources.length == 0) {
                topApi.get<ResourceResponse>('/security/getResources').then((res) => {
                    if (res.status == 200) {
                        setResources(res.data.resources);
                    }
                });
            }

            await localStorage.setItem('token', resp.data.token);
            dispatch({
                type: 'signUp',
                payload: {
                    token: resp.data.token,
                    user: resp.data.user
                }
            });
        } catch (error) {
            return dispatch({ type: 'notAuthenticated' });
        }
    }


    const login = async ({ correo, password, retry, otp }: LoginData) => {

        try {


            dispatch({ type: 'isLoging' });

            if (correo.length == 0 || password.length == 0) {
                dispatch({
                    type: 'addError',
                    payload: 'Usuario y/o contraseña son requeridos.'
                });
                return;
            }


            var deviceId = '123';

            const { data } = await topApi.post<LoginResponse>('/auth/login', { user: correo, password, retry, deviceId, otp });

            if (data.status == "OTP_SENT") {
                dispatch({
                    type: 'addError',
                    payload: 'Te enviamos un OTP al correo. Ingresa el código para continuar.'
                });
                return;
            }


            dispatch({
                type: 'signUp',
                payload: {
                    token: data.token,
                    user: data.user
                }
            });


            topApi.get<ResourceResponse>('/security/getResources').then((res) => {
                if (res.status == 200) {
                    setResources(res.data.resources);
                }
            });


            await localStorage.setItem('token', data.token);

        } catch (error) {
            dispatch({
                type: 'addError',
                payload: error.response.data.error
                    || 'Información incorrecta'
            })
        }
    };


    const loginWithOracleCode = async (code: String) => {

        try {


            dispatch({ type: 'isLoging' });


            const { data } = await topApi.post<LoginResponse>('/auth/loginWithOracleCode', { code: code });


            dispatch({
                type: 'signUp',
                payload: {
                    token: data.token,
                    user: data.user

                }
            });


            topApi.get<ResourceResponse>('/security/getResources').then((res) => {
                if (res.status == 200) {
                    setResources(res.data.resources);
                }
            });


            await localStorage.setItem('token', data.token);
            await localStorage.setItem('idOracleToken', data.idOracleToken);


            return true;


        } catch (error) {
            dispatch({
                type: 'addError',
                payload: error.response.data.error
                    || 'Información incorrecta'
            })

            return false;

        }
    };


    const logout = async () => {
        await localStorage.removeItem('token');
        sessionStorage.clear();
        const ORACLE_HOST = process.env.REACT_APP_ORACLE_HOST;

        const idOracleToken = await localStorage.getItem('idOracleToken');

        const oracleLogoutUrl =
            `${ORACLE_HOST}/oauth2/v1/userlogout` +
            `?id_token_hint=${encodeURIComponent(idOracleToken)}` +
            `&post_logout_redirect_uri=${encodeURIComponent(
                window.location.origin + "/login"
            )}`;
        window.location.href = oracleLogoutUrl;

        dispatch({ type: 'logout' });
    };

    const removeError = () => {
        dispatch({ type: 'removeError' });
    };

    const resetPassword = async (username: string) => {
        try {

            if (username.length == 0) {
                dispatch({
                    type: 'addError',
                    payload: 'Usuario requerido para recuperar contraseña.'
                });
                return;
            }

            dispatch({ type: 'isLoging' });


            const headers = {
                'x-username': username
            };

            const resp = await topApi.put('/auth/resetPassword', null, { headers });
            if (resp.status !== 200) {
                dispatch({
                    type: 'addError',
                    payload: resp.data.error
                        || 'Ocurrió un error de comunicación, intente de nuevo.'
                });
                return;
            }

            dispatch({
                type: 'addMessage',
                payload: 'Se ha enviado un correo para reestablecer su contraseña.'
            });

        } catch (error) {
            dispatch({
                type: 'addError',
                payload: error?.response?.data?.error
                    || 'Ocurrió un error de comunicación, intente de nuevo.'
            })

        }
    };


    return (
        <AuthContext.Provider value={{
            ...state,
            resources,
            login,
            logout,
            removeError,
            resetPassword,
            loginWithOracleCode
        }}>
            {children}
        </AuthContext.Provider>
    )

}